import type { FC } from 'react'
import { useNavigate } from 'react-router'

import type { ActivityDto, SingleTicketDto } from '@hcr/api/consumer'
import { find, flow, getPropertyValue, isNotUndefined } from '@hcr/utils'

import { useHoliday } from '../../../../../contexts'
import { useDestinationsQuery } from '../../../../../hooks'
import { Path } from '../../../../../models'
import { isDestinationOf, to } from '../../../../../utils'
import type { BookingListPreview } from '../../types'

interface BookingListPreviewTicketProps {
  component: BookingListPreview
  ticket: SingleTicketDto | ActivityDto
  totalTickets: number
}

export const BookingListPreviewTicket: FC<BookingListPreviewTicketProps> = ({
  component: Component,
  ticket,
  totalTickets,
}) => {
  const holiday = useHoliday()
  const navigate = useNavigate()

  const destination = useDestinationsQuery({
    select: flow(getPropertyValue('destinations'), find(isDestinationOf(ticket))),
  })

  if (holiday.isSuccess && destination.isSuccess && isNotUndefined(destination.data)) {
    return (
      <Component
        destinationId={destination.data.destinationId}
        destinationName={destination.data.title}
        isActive={destination.data.destinationId === holiday.data.destinationId}
        onClick={() => {
          if (isNotUndefined(destination.data)) {
            holiday.setDestinationId(destination.data.destinationId)
          }

          void navigate(to(Path.Booking))
        }}
        totalTickets={totalTickets}
      />
    )
  }

  return null
}
